import React, { Fragment } from 'react';

import { Button, Dialog, Grid, } from '@mui/material'
import MuiDialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';

const LocationMap = ({ maxWidth, button, buttonClass }) => {
    const [open, setOpen] = React.useState(false);

    function handleClickOpen() {
        setOpen(true);
    }

    function handleClose() {
        setOpen(false);
    }


    const DialogTitle = ((props) => {
        const { onClose } = props;
        return (
            <MuiDialogTitle>
                {onClose ? (
                    <IconButton className='event-close-btn' aria-label="close" onClick={onClose}>
                        <i className="ti-close"></i>
                    </IconButton>
                ) : null}
            </MuiDialogTitle>
        );
    });


    return (
        <Fragment>
            <Button
                className={`btn ${buttonClass}`}
                onClick={handleClickOpen}
                style={{ fontSize: '22px' }}>
                {button}
                Ver ubicación
            </Button>
            <Dialog
                open={open}
                onClose={handleClose}
                className="modalWrapper quickview-dialog"
                maxWidth={maxWidth}
            >
                <DialogTitle id="customized-dialog-title" onClose={handleClose}> </DialogTitle>
                <Grid className="modalBody modal-body">
                    <Grid className="modalBody modal-body">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3766.6849966824!2d-99.09506682489507!3d19.252555481988733!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85ce03f981aeb4f9%3A0xf1b5b983b9b84712!2sHacienda%20Zacapa!5e0!3m2!1ses-419!2smx!4v1748736887754!5m2!1ses-419!2smx"></iframe>                    </Grid>
                </Grid>
            </Dialog>
        </Fragment>
    );
}
export default LocationMap


